import {
  CheckboxInput,
  FormItem,
  MenuPresets,
  RadioGroupInput,
  TextInput,
} from '@framework/form';
import { RowElement } from '@framework/ui';
import { yup } from '@framework/validation';
import React from 'react';
import { BooleanConditionSchema } from '../../../../../inputs/expressions-editor/conditions/BooleanConditionSchema';
import { RichTextAdvancedInput } from '../../../../../inputs/rich-text-advanced/RichTextAdvancedInput';
import { RichTextAdvancedSchema } from '../../../../../inputs/rich-text-advanced/schema/RichTextAdvancedSchema';
import { IWidgetComponentProps } from '../../../IWidgetType';
import { WidgetType } from '../../../Widget';
import { BaseLayoutColSpanInput } from '../../common/BaseLayoutColSpanInput';
import { BaseLayoutSchema } from '../../common/BaseLayoutSchema';
import { getWidgetProps } from '../../inputs/common/util/getWidgetProps';
import { CommonGraphicWidgetConfigSchema } from '../common/CommonGraphicWidgetConfigSchema';
import { IInfoWidget } from './IInfoWidget';

export const InfoWidgetConfigSchema = CommonGraphicWidgetConfigSchema.shape({
  type: yup.string().exact(WidgetType.Info).required(),
  body: RichTextAdvancedSchema.optional().label('Testo'),
  // Regole di visibilità
  visible: BooleanConditionSchema,

  layout: BaseLayoutSchema.shape({
    showIcon: yup.boolean().required().default(false).label("Mostra l'icona"),
    collapsible: yup.boolean().required().default(false).label('Contraibile'),
    collapsibleBody: RichTextAdvancedSchema.optional().label('Testo contratto'),
    collapsibleExpandText: yup
      .string()
      .notRequired()
      .label('Testo di espansione'),
    collapsibleCollapseText: yup
      .string()
      .notRequired()
      .label('Testo di contrazione'),
    type: yup
      .string()
      .oneOf(['info', 'warning', 'success', 'error', 'default'])
      .required()
      .default('info')
      .label('Tipo Messaggio'),
  })
    .required()
    .noUnknown(),
}) satisfies yup.ObjectSchema<IInfoWidget>;

export interface IInfoWidgetConfigComponentProps
  extends IWidgetComponentProps<IInfoWidget> {}

export function InfoWidgetConfigComponent(
  props: IInfoWidgetConfigComponentProps,
) {
  const options = getWidgetProps(props);

  return (
    <div>
      <FormItem name="body" label="Testo">
        <RichTextAdvancedInput
          name="body"
          menus={MenuPresets.Block}
          rows={10}
        />
      </FormItem>
      <FormItem name="layout.type" label="Tipologia di messaggio">
        <RadioGroupInput
          name="layout.type"
          defaultValue={'info'}
          options={[
            { label: 'Box Informativo', value: 'info' },
            { label: 'Box di Avviso', value: 'warning' },
            { label: 'Box di Successo', value: 'success' },
            { label: 'Box di Errore', value: 'error' },
            { label: 'Box di Default', value: 'default' },
          ]}
        />
      </FormItem>

      <RowElement>
        <FormItem name="layout.showIcon" label="Mostra l'icona">
          <CheckboxInput name="layout.showIcon" defaultChecked={false}>
            Mostra un icona prima del messaggio
          </CheckboxInput>
        </FormItem>
        <BaseLayoutColSpanInput isTableColumn={options.isTableColumn} />
      </RowElement>

      <FormItem name="layout.collapsible" label="Contraibile">
        <CheckboxInput name="layout.collapsible" defaultChecked={false}>
          Abilita il meccanismo &laquo;Contrai/Espandi&raquo; del paragrafo
        </CheckboxInput>
      </FormItem>
      <FormItem
        name="layout.collapsibleBody"
        label="Testo contratto"
        help="Testo da visualizzare quando il paragrafo è contratto."
      >
        <RichTextAdvancedInput
          name="layout.collapsibleBody"
          menus={MenuPresets.Block}
          rows={10}
        />
      </FormItem>
      <RowElement>
        <FormItem
          name="layout.collapsibleExpandText"
          label="Testo di espansione"
        >
          <TextInput
            name="layout.collapsibleExpandText"
            placeholder="Espandi"
          />
        </FormItem>
        <FormItem
          name="layout.collapsibleCollapseText"
          label="Testo di contrazione"
        >
          <TextInput
            name="layout.collapsibleCollapseText"
            placeholder="Contrai"
          />
        </FormItem>
      </RowElement>
    </div>
  );
}
